(function (angular) {
  "use strict";

  var LOCAL_STORAGE_KEY = "variant_saved_options";

  angular.module("Toyota.Directives").directive("tyPricingVariantSelector", [
    "Animations",
    "HttpPendingRequestsService",
    function (Animations, HttpPendingRequestsService) {
      var controller = [
          "$scope",
          "$element",
          "PricingPageAnalyticsService",
          "$filter",
          "Range",
          "localstorage",
          function ($scope, $element, PricingPageAnalyticsService, $filter, Range, localstorage) {
            var ctl = this;

            var allOptionCategories = {
              cabChassis: {
                optionSelector: ".ty-pricing-variant-selector__items--cab-chassis .ty-pricing-variant-selector__radio",
                variantOptionsKey: "cabChassis",
              },
              drivetrain: {
                optionSelector: ".ty-pricing-variant-selector__items--drivetrain .ty-pricing-variant-selector__radio",
                variantOptionsKey: "drivetrains",
              },
              engineType: {
                optionSelector: ".ty-pricing-variant-selector__items--engine-type .ty-pricing-variant-selector__radio",
                variantOptionsKey: "engineTypes",
              },
              transmission: {
                optionSelector: ".ty-pricing-variant-selector__items--transmission .ty-pricing-variant-selector__radio",
                variantOptionsKey: "transmissions",
              },
              seatOption: {
                optionSelector: ".ty-pricing-variant-selector__items--seat-option .ty-pricing-variant-selector__radio",
                variantOptionsKey: "seatOptions",
              },
            };

            // This array determines the order which the variants are processed.
            var optionCategories = ["cabChassis", "drivetrain", "engineType", "transmission", "seatOption"];

            var hasTrayOption = false;
            var firstPass = true;
            var cabChassisDescriptionMapping = {};

            function init() {
              initSavedOption();
              getCabChassisDescriptionMapping();
            }

            function initSavedOption() {
              localstorage.remove(LOCAL_STORAGE_KEY);
              $scope.savedOption = {};
            }

            function getCabChassisDescriptionMapping() {
              var cabChassisOptions = getAllCabChassisOptions();

              cabChassisOptions.forEach(function (cabChassis) {
                var variants = getAllVariantsByCabChassis(cabChassis);

                var doorOptions = variants
                  .map(function (variant) {
                    return variant.doors;
                  })
                  .filter(function (item, index, array) {
                    // remove falsy and duplicate items in the array.
                    return array.indexOf(item) === index;
                  })
                  .sort();

                var seatOptions = variants
                  .map(function (variant) {
                    return variant.seats;
                  })
                  .filter(function (item, index, array) {
                    // remove falsy and duplicate items in the array.
                    return array.indexOf(item) === index;
                  })
                  .sort();

                cabChassisDescriptionMapping[cabChassis] = {
                  doorOptions: doorOptions,
                  seatOptions: seatOptions,
                };
              });
            }

            function getAllVariantsByCabChassis(cabChassis) {
              var gradesList = Range.getGradesList();
              var variants = [];

              gradesList.forEach(function (grade) {
                grade.variants.forEach(function (variant) {
                  if (variant.cabChassis === cabChassis) {
                    variants.push(variant);
                  }
                });
              });

              return variants;
            }

            function getAllCabChassisOptions() {
              var gradesList = Range.getGradesList();
              var cabChassisOptions = [];

              gradesList.forEach(function (grade) {
                grade.variants.forEach(function (variant) {
                  if (cabChassisOptions.indexOf(variant.cabChassis) === -1) {
                    cabChassisOptions.push(variant.cabChassis);
                  }
                });
              });

              return cabChassisOptions;
            }

            function getFirstSelectedVariant(calculatedVariantIds) {
              var analyticsVariantId = calculatedVariantIds[0];
              var grade = Range.getGradeByIdFromCache($scope.grade.id);
              return grade.variants.find(function (variant) {
                return variant.id === analyticsVariantId;
              });
            }

            ctl.updateVariantIds = function (source, variantType) {
              var variants = getVariantsFromGrade($scope.grade.id);
              var selectedVariantId;

              if (firstPass && ctl.initialVariantId) {
                firstPass = false;
                selectedVariantId = ctl.initialVariantId;
                resetVariantFromId(selectedVariantId);
              } else if (source === "grade") {
                showHideCabChassisSelector($scope.grade.containsCabChassis);

                selectedVariantId = calculateClosestVariantId(variants);
                resetVariantFromId(selectedVariantId);
              }

              disableImpossibleSelections();
              ctl.updateTrayOptionCategoryVisibility();

              var calculatedVariantIds = calculateSelectedVariantIds();
              PricingPageAnalyticsService.setVariant(getFirstSelectedVariant(calculatedVariantIds));

              if (source === "variant") {
                PricingPageAnalyticsService.triggerAnalytics("gaClick", {
                  eventCategory: "pricing",
                  eventAction: "button - " + variantType,
                  eventLabel: $scope.savedOption[variantType],
                });
              }

              emitChange(calculatedVariantIds, source);
            };

            function showHideCabChassisSelector(containsCabChassis) {
              var $cabChassisOptionCategory = $element.find(
                ".ty-pricing-variant-selector__option-category--cab-chassis"
              );
              if (containsCabChassis) {
                Animations.slideThenFadeIn($cabChassisOptionCategory);
              } else {
                Animations.fadeThenSlideOut($cabChassisOptionCategory);
              }
            }

            ctl.cabChassisDescription = function (cabChassis) {
              if ($scope.grade && $scope.grade.containsCabChassis) {
                var variants = getVariantsFromGrade($scope.grade.id);

                var variant = variants.find(function (variant) {
                  return variant.cabChassis === cabChassis;
                });

                if (variant) {
                  return cabChassisDescriptionString(variant.doors, variant.seats);
                }
              }

              var descriptionDetails = cabChassisDescriptionMapping[cabChassis];

              if (descriptionDetails.doorOptions.length === 1 && descriptionDetails.seatOptions.length === 1) {
                return cabChassisDescriptionString(
                  descriptionDetails.doorOptions[0],
                  descriptionDetails.seatOptions[0]
                );
              }

              var doors = descriptionDetails.doorOptions[descriptionDetails.doorOptions.length - 1];
              var seats = descriptionDetails.seatOptions[descriptionDetails.seatOptions.length - 1];
              return "Up to " + cabChassisDescriptionString(doors, seats);
            };

            function cabChassisDescriptionString(doors, seats) {
              return doors + " door, " + seats + " seat";
            }

            ctl.updateTrayOptionCategoryVisibility = function () {
              var variants = getVariantsFromGrade($scope.grade.id);
              var calculatedVariantIds = calculateSelectedVariantIds();

              var currentlySelectedVariants = variants.filter(function (variant) {
                return calculatedVariantIds.includes(variant.id);
              });

              var currentlySelectedVariantsWithTray = currentlySelectedVariants.filter(function (variant) {
                return !!variant.tray.attributeValue && variant.tray.accessoryCode;
              });

              if (currentlySelectedVariantsWithTray.length === 0) {
                hasTrayOption = false;
              } else {
                hasTrayOption = true;
                $scope.trayOptionLabel = currentlySelectedVariantsWithTray[0].tray.attributeValue;
                $scope.accessoryCode = currentlySelectedVariantsWithTray[0].tray.accessoryCode;
              }

              var $trayOptionCategory = $element.find(".ty-pricing-variant-selector__option-category--tray");
              if (hasTrayOption) {
                Animations.slideThenFadeIn($trayOptionCategory);
              } else {
                Animations.fadeThenSlideOut($trayOptionCategory);
              }
            };

            function selectOption($option) {
              $option
                .closest(".ty-pricing-variant-selector__items")
                .find(".ty-pricing-variant-selector__item")
                .prop("checked", false);
              $option.prop("checked", true);
            }

            function resetVariantFromId(variantId) {
              angular.forEach(optionCategories, function (optionCategory) {
                var $option = findOption(optionCategory, getOptionFromVariant(optionCategory, variantId));
                if ($option.length) {
                  selectOption($option);
                }
              });
            }

            function calculateSelectedVariantIds() {
              var variantIdSets = [];

              angular.forEach(optionCategories, function (optionCategory) {
                variantIdSets.push(getSelectedVariantIds(optionCategory));
              });

              return combineVariantIdSets(variantIdSets);
            }

            function combineVariantIdSets(variantIdSets) {
              if (variantIdSets.length === 0) {
                throw new Error("combineVariantIds requires an array containing at least one variantId array");
              }

              var variantIdSetsSanitized = angular.copy(variantIdSets);
              variantIdSetsSanitized = variantIdSetsSanitized.filter(function (el) {
                return typeof el !== "undefined";
              });

              var allVariantIds = variantIdSetsSanitized[0];

              if (variantIdSetsSanitized.length > 1) {
                angular.forEach(variantIdSetsSanitized, function (variantIdSet) {
                  if (!(variantIdSet instanceof Array)) {
                    return;
                  }

                  allVariantIds = $filter("arrayIntersect")(allVariantIds, variantIdSet);
                });
              }

              return filterVariantsByGrade(allVariantIds, $scope.grade.id);
            }

            function getSelectedVariantIds(optionCategory) {
              return angular.fromJson(getSelectedOption(optionCategory).data("variant-ids"));
            }

            function getSelectedOption(optionCategory) {
              return getAllOptions(optionCategory).filter(":checked");
            }

            function filterVariantsByGrade(variantIds, gradeId) {
              var variantsInGrade = getVariantIdsFromGrade(gradeId);

              return variantIds.filter(function (variantId) {
                return variantsInGrade.indexOf(variantId) !== -1;
              });
            }

            function getVariantsFromGrade(gradeId) {
              return Range.getVariantsByGradeIdFromCache(gradeId);
            }

            function getVariantIdsFromGrade(gradeId) {
              return getVariantsFromGrade(gradeId).map(function (variant) {
                return variant.id;
              });
            }

            function getAllOptions(optionCategory) {
              return $element.find(allOptionCategories[optionCategory].optionSelector);
            }

            function disableImpossibleSelections() {
              var variantIdSets = [getVariantIdsFromGrade($scope.grade.id)];

              angular.forEach(optionCategories, function (optionCategory) {
                var $options = getAllOptions(optionCategory);
                disableOptionGroup($options, variantIdSets);

                var $selectedOption = getSelectedOption(optionCategory);
                if ($selectedOption.length === 0) {
                  var updateSuccessful = updateToSavedUserSelection(optionCategory);

                  if (!updateSuccessful) {
                    var selectedVariantId = combineVariantIdSets(variantIdSets)[0];
                    var $option = findOption(optionCategory, getOptionFromVariant(optionCategory, selectedVariantId));
                    if ($option.length) {
                      selectOption($option);
                    }
                  }
                }

                if ($options.length) {
                  variantIdSets.push(getSelectedVariantIds(optionCategory));
                }
              });
            }

            function updateToSavedUserSelection(optionCategory) {
              if ($scope.savedOption[optionCategory]) {
                var $option = findOption(optionCategory, $scope.savedOption[optionCategory]);
                if ($option.length && !$option.prop("disabled")) {
                  selectOption($option);
                  return true;
                }
              }

              return false;
            }

            function disableOptionGroup($targetOptionGroup, variantIdSets) {
              var $availableOptions = $targetOptionGroup.filter(function (index, option) {
                var variantIdsForOption = angular.fromJson(angular.element(option).data("variant-ids"));
                var variantIdSetsToCombine = [variantIdsForOption].concat(variantIdSets);
                return combineVariantIdSets(variantIdSetsToCombine).length > 0;
              });

              $targetOptionGroup
                .prop("disabled", false)
                .not($availableOptions)
                .prop("disabled", true)
                .prop("checked", false);
            }

            function getOptionFromVariant(optionCategory, variantId) {
              var optionType = Range.getVariantOptionsFromCache()[
                allOptionCategories[optionCategory].variantOptionsKey
              ];
              var foundOption = optionType.filter(function (option) {
                var foundVariant = $filter("arrayFind")(option.variantIds, function (id) {
                  return id === variantId;
                });

                return typeof foundVariant !== "undefined";
              });

              return foundOption.length > 0 ? foundOption[0].option : null;
            }

            function findOption(optionCategory, optionName) {
              return $element.find('[data-variant-type="' + optionCategory + '"][data-option="' + optionName + '"]');
            }

            function calculateClosestVariantId(variants) {
              var variantMatches = getVariantMatchCounts(variants);
              var highestMatchCount = Math.max.apply(null, variantMatches);

              if (highestMatchCount === 0) {
                return $scope.grade.baseVariantId;
              }

              var variantIndex = variantMatches.indexOf(highestMatchCount);

              return variants[variantIndex].id;
            }

            function getVariantMatchCounts(variants) {
              return variants.map(function (variant) {
                var matchCount = 0;

                Object.keys($scope.savedOption).forEach(function (key) {
                  if (variant[key] === $scope.savedOption[key]) {
                    matchCount++;
                  }
                });

                return matchCount;
              });
            }

            ctl.$onInit = init;

            $scope.$watch("tyPricingVariantSelector.variantIdsInputData", function (variantIdsInputData) {
              if (!variantIdsInputData) {
                return;
              }

              $scope.grade = variantIdsInputData.grade;

              // need to recalc variant ids in case we have several available - such as 1 tone and 2 tone
              ctl.updateVariantIds("grade");
            });

            function emitChange(variantIds, source) {
              if (source !== "grade") {
                HttpPendingRequestsService.cancelAll();
              }

              var pricingPageVariantIdsChangedData = {
                grade: $scope.grade,
                variantIds: variantIds,
                source: source,
              };
              ctl.onVariantsChange(pricingPageVariantIdsChangedData);
            }

            $scope.$watch(
              "savedOption",
              function (newValue, oldValue) {
                if (newValue !== oldValue) {
                  localstorage.set(LOCAL_STORAGE_KEY, newValue);
                }
              },
              true
            );

            $scope.$on("update-variant-options", function (event, options) {
              $scope.savedOption = options;
            });
          },
        ],
        link = function ($scope, $element, $attrs, $ctrl, $transclude) {
          $transclude($scope, function (clone) {
            $element.append(clone);
          });

          function init() {
            var $trayOptionCategory = $element.find(".ty-pricing-variant-selector__option-category--tray");
            Animations.hide($trayOptionCategory);
          }

          init();

          $element.find(".ty-pricing-variant-selector__items").each(function (index, group) {
            var $group = angular.element(group);
            $group.find(".ty-pricing-variant-selector__radio").on("change", function (event) {
              var $selection = angular.element(event.target);
              var variantType = $selection.data("variant-type");
              var option = $selection.data("option");

              $scope.savedOption[variantType] = option;
              $scope.tyPricingVariantSelector.updateVariantIds("variant", variantType);
            });

            $group.find(".ty-pricing-variant-selector__item").on("click", function () {
              if (angular.element(this).prev().prop("disabled")) {
                // TODO: Don't trigger analytics on disabled element
              }
            });
          });
        };

      return {
        bindToController: {
          onVariantsChange: "<tyPricingVariantSelectorOnVariantsChange",
          variantIdsInputData: "<tyPricingVariantSelectorVariantIdsInputData",
          initialVariantId: "<tyPricingVariantSelectorInitialVariantId",
        },
        controller: controller,
        controllerAs: "tyPricingVariantSelector",
        link: link,
        restrict: "A",
        scope: {},
        transclude: true,
      };
    },
  ]);
})(window.angular);
